import { template as template_78942682edf447d78753ce4ba7c2946c } from "@ember/template-compiler";
import { hash } from '@ember/helper';
const BlankTemplate = template_78942682edf447d78753ce4ba7c2946c(`
<div ...attributes>
  {{yield}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_78942682edf447d78753ce4ba7c2946c(`
  {{yield
    (hash
      taskDetails=BlankTemplate
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
